import { PlanningBlock } from "../models/planning-block/planning-block.interface";
export function sortPlanningBlocks(planningBlocks: any): any[] {
    let orderPBsByContainerType: any[] = [];

    if (planningBlocks.length > 1) {
        let depotInPBs = planningBlocks.filter((pb, index) => pb.containerPlanningType == 2);  //DepotIn
        let depotOutPBs = planningBlocks.filter((pb, index) => pb.containerPlanningType ==1);  //DepotOut
        let depotInOutOPbs = planningBlocks.filter((pb, index) => pb.containerPlanningType == 4);  //DepotIn /Out
        let othersPbs = planningBlocks.filter((pb, index) => ![1, 2, 4].includes(pb.containerPlanningType));  //Others 
        orderPBsByContainerType = [...depotInPBs, ...depotInOutOPbs , ...depotOutPBs,...othersPbs];
    }
    else
        orderPBsByContainerType = [...planningBlocks];
    return orderPBsByContainerType;
}